export const DECORATED_ERROR_CONTEXT_KEY = '__reportingContext';
